export enum ErrorMessage {
  NotFound = 'NotFound',
  InternalServerError = 'InternalServerError'
}

export const ErrorCodes = {
  [ErrorMessage.NotFound]: '404',
  [ErrorMessage.InternalServerError]: '500'
};
